const TURKEY_COUNTRY_ID = '1';
    function searchUiText(source, replacements = {}) {
        const table = (window.HOME_SEARCH_I18N && typeof window.HOME_SEARCH_I18N === 'object')
            ? window.HOME_SEARCH_I18N
            : {};
        const fragments = (table.__fragments && typeof table.__fragments === 'object')
            ? table.__fragments
            : {};

        let text = Object.prototype.hasOwnProperty.call(table, source)
            ? String(table[source])
            : String(source ?? '');

        if (text === String(source ?? '') && text) {
            Object.keys(fragments)
                .sort((a, b) => b.length - a.length)
                .forEach(fragment => {
                    if (!fragment || !text.includes(fragment)) return;
                    text = text.split(fragment).join(String(fragments[fragment]));
                });
        }

        Object.entries(replacements || {}).forEach(([key, value]) => {
            text = text.split(':' + key).join(String(value ?? ''));
        });

        return text;
    }


function selectedLocation(form) {
    return ['acCityId', 'acDistrictId', 'acQuarterId'].some(id => {
        const input = form.querySelector('#' + id);
        return input && !input.disabled && /^[1-9]\d*$/.test(String(input.value).trim());
    });
}
function searchQuery(form) {
    const mobileOpen = document.getElementById('hmMobileSearchOut')?.classList.contains('is-open');
    const input = mobileOpen ? document.getElementById('hmMobileSearchQ') : document.getElementById('hsQ');
    return String(input ? input.value : (form.querySelector('#qHidden')?.value || '')).trim();
}
export function validateHeroSearch(form, notify = true) {
    const ai = form.querySelector('#hsAi')?.value === '1';
    const text = searchQuery(form);
    const valid = ai ? text.length >= 2 : selectedLocation(form);
    if (valid || !notify) return valid;
    const labels = window.HM_HERO_SEARCH_I18N || {};
    const mobile = document.getElementById('hmMobileSearchOut');
    const input = mobile?.classList.contains('is-open') ? document.getElementById('hmMobileSearchQ') : document.getElementById('hsQ');
    const field = input?.closest('.hm-mobile-location-field, .hero-search-input');
    field?.classList.add('is-location-required');
    input?.setAttribute('aria-invalid', 'true');
    input?.focus({ preventScroll: true });
    if (!ai) document.getElementById('hmMobileSearchError')?.removeAttribute('hidden');
    window.UI?.toast('warning', labels.title || 'Bölge gerekli', ai ? (labels.ai || 'Hayalinizdeki evi tarif edin') : (labels.message || 'Arama yapabilmek için önce şehir, ilçe veya mahalle seçiniz.'));
    return false;
}
function navigateHeroSearch(url) {
    if (document.getElementById('hmMobileSearchOut')?.classList.contains('is-open') && window.HMHomeMobileSearch?.navigate) {
        window.HMHomeMobileSearch.navigate(url);
    } else {
        window.location.assign(url);
    }
}
window.HMHeroSearch = { validate: validateHeroSearch };

export function initHeroSearchSubmission() {
        const form = document.getElementById('heroSearchForm');
        if (!form || form.dataset.filterSubmitSyncBound === '1') return;

        form.dataset.filterSubmitSyncBound = '1';

        const RECENT_KEY = 'recent_searches_v4';
        const HANDOFF_KEY = 'home_last_search_params_v2';
        const MAX_RECENT = 12;

        function clean(value) {
            return String(value ?? '').trim();
        }

        function normalizeNumberString(value) {
            let valueText = clean(value);
            if (!valueText) return '';

            return valueText
                .replace(/\s*(₺|tl|try|m²|m2|㎡|metrekare|sqm)\s*/giu, '')
                .replace(/[^0-9,.-]/g, '')
                .replace(/\./g, '')
                .replace(',', '.');
        }

        function paramsToObject(params) {
            const out = {};

            params.forEach((value, key) => {
                if (out[key] === undefined) {
                    out[key] = value;
                    return;
                }

                if (!Array.isArray(out[key])) {
                    out[key] = [out[key]];
                }

                out[key].push(value);
            });

            return out;
        }

        function saveRecentSearch(params, url) {
            try {
                const obj = paramsToObject(params);

                const ignored = new Set([
                    'mode',
                    'ai',
                    'transaction_type',
                    'main_category_id',
                    'subcategory_id',
                ]);

                const hasMeaningful = Object.entries(obj).some(([key, value]) => {
                    if (ignored.has(key)) return false;
                    if (Array.isArray(value)) return value.some(v => clean(v) !== '');
                    return clean(value) !== '';
                });

                if (!hasMeaningful) return;

                const current = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
                const list = Array.isArray(current) ? current : [];
                const signature = JSON.stringify(obj);

                const item = {
                    type: 'search',
                    source: 'home',
                    url,
                    href: url,
                    params: obj,
                    filters: obj,
                    search: obj,
                    signature,
                    created_at: new Date().toISOString(),
                    updated_at: Date.now(),
                };

                const next = [item]
                    .concat(list.filter(old => {
                        if (!old) return false;
                        if (old.url && old.url === url) return false;
                        if (old.href && old.href === url) return false;
                        if (old.signature && old.signature === signature) return false;
                        if (old.params && JSON.stringify(old.params) === signature) return false;
                        return true;
                    }))
                    .slice(0, MAX_RECENT);

                localStorage.setItem(RECENT_KEY, JSON.stringify(next));
                sessionStorage.setItem(HANDOFF_KEY, JSON.stringify({ params: obj, url, at: Date.now() }));
            } catch (error) {
                console.warn('[home] recent search save failed:', error);
            }
        }

        function appendFormData(params, formData) {
            formData.forEach((value, key) => {
                value = clean(value);

                if (!key || value === '' || key === '_token' || key === 'hero_main_category') {
                    return;
                }

                params.delete(key);
                params.set(key, value);
            });
        }

        function syncHeroParams(params) {
            const mode = clean(document.getElementById('hsSearchMode')?.value || 'ad');
            const ai = clean(document.getElementById('hsAi')?.value || '0');
            const transactionType = clean(document.getElementById('hsTransactionType')?.value || '1');

            const mainCategoryId = clean(document.getElementById('mainCategoryIdHidden')?.value || '');
            const subCategoryId = clean(document.getElementById('subCategoryIdHidden')?.value || '');
            const categoryId = clean(subCategoryId || mainCategoryId || document.getElementById('categoryIdHidden')?.value || '');

            const countryId = TURKEY_COUNTRY_ID;
            const cityId = clean(document.getElementById('acCityId')?.value || '');
            const districtId = clean(document.getElementById('acDistrictId')?.value || '');
            const quarterId = clean(document.getElementById('acQuarterId')?.value || '');
            const locationLabel = clean(
                document.getElementById('acLocationLabel')?.value ||
                document.querySelector('#hsLocationTag span')?.textContent ||
                ''
            );

            const hsQ = document.getElementById('hsQ');
            const qHidden = document.getElementById('qHidden');
            const tag = document.getElementById('hsLocationTag');
            const tagVisible = !!locationLabel && (!tag || tag.style.display !== 'none');

            params.delete('page');
            params.delete('include_map');
            ['lat', 'lng', 'radius', 'radius_mode', 'radius_label', 'bbox', 'poly'].forEach(key => params.delete(key));

            params.set('mode', mode || 'ad');

            if (ai === '1') {
                params.set('ai', '1');

                [
                    'category_id',
                    'main_category_id',
                    'subcategory_id',
                    'city_id',
                    'district_id',
                    'quarter_id',
                    'location_label',
                    'min_price',
                    'max_price',
                    'price_min',
                    'price_max',
                    'm2_min',
                    'm2_max',
                    'has_virtual_tour',
                    'bbox',
                    'poly',
                ].forEach(key => params.delete(key));

                Array.from(params.keys()).forEach(key => {
                    if (key.startsWith('fields[') || key.startsWith('feature_value_ids')) {
                        params.delete(key);
                    }
                });

                const aiText = searchQuery(form);
                if (aiText) params.set('q', aiText);
                else params.delete('q');

                params.set('country_id', TURKEY_COUNTRY_ID);

                return params;
            }

            params.delete('ai');

            if (transactionType === '1' || transactionType === '2') {
                params.set('transaction_type', transactionType);
            }

            if (mainCategoryId) params.set('main_category_id', mainCategoryId);
            else params.delete('main_category_id');

            if (subCategoryId) params.set('subcategory_id', subCategoryId);
            else params.delete('subcategory_id');

            if (categoryId) params.set('category_id', categoryId);
            else params.delete('category_id');

            params.set('country_id', TURKEY_COUNTRY_ID);

            if (cityId) params.set('city_id', cityId);
            else params.delete('city_id');

            if (districtId) params.set('district_id', districtId);
            else params.delete('district_id');

            if (quarterId) params.set('quarter_id', quarterId);
            else params.delete('quarter_id');

            if (locationLabel) params.set('location_label', locationLabel);
            else params.delete('location_label');

            if (!tagVisible) {
                const q = clean(hsQ?.value || qHidden?.value || '');
                if (q) params.set('q', q);
                else params.delete('q');
            } else {
                params.delete('q');
            }

            return params;
        }

        function normalizeFilterParams(params) {
            const minPrice = normalizeNumberString(params.get('min_price') || params.get('price_min') || '');
            const maxPrice = normalizeNumberString(params.get('max_price') || params.get('price_max') || '');

            if (minPrice) {
                params.set('min_price', minPrice);
                params.set('price_min', minPrice);
            } else {
                params.delete('min_price');
                params.delete('price_min');
            }

            if (maxPrice) {
                params.set('max_price', maxPrice);
                params.set('price_max', maxPrice);
            } else {
                params.delete('max_price');
                params.delete('price_max');
            }

            ['m2_min', 'm2_max'].forEach(key => {
                const value = normalizeNumberString(params.get(key) || '');
                if (value) params.set(key, value);
                else params.delete(key);
            });

            return params;
        }

        function buildTargetUrl(params) {
            const url = new URL(form.getAttribute('action') || window.location.href, window.location.origin);

            params.forEach((value, key) => {
                if (!key || key === '_token' || clean(value) === '') return;

                url.searchParams.append(key, clean(value));
            });

            return url.toString();
        }

        form.addEventListener('submit', function (event) {
            if (event.defaultPrevented) return;
            event.preventDefault();
            if (!validateHeroSearch(form)) return;

            const mode = clean(document.getElementById('hsSearchMode')?.value || 'ad');
            const ai = clean(document.getElementById('hsAi')?.value || '0');

            if (mode === 'agency') {
                const agencyUrl = new URL(form.dataset.actionAgency || form.getAttribute('action'), window.location.origin);
                agencyUrl.searchParams.set('country_id', TURKEY_COUNTRY_ID);
                const params = new URLSearchParams();

                appendFormData(params, new FormData(form));
                syncHeroParams(params);

                params.delete('category_id');
                params.delete('main_category_id');
                params.delete('subcategory_id');
                params.delete('transaction_type');
                params.delete('ai');

                params.forEach((value, key) => {
                    agencyUrl.searchParams.set(key, value);
                });

                navigateHeroSearch(agencyUrl.toString());
                return;
            }

            let params = new URLSearchParams();

            if (window.NetteSearchFilter && typeof window.NetteSearchFilter.buildParams === 'function' && ai !== '1') {
                params = new URLSearchParams(window.NetteSearchFilter.buildParams().toString());
            } else {
                appendFormData(params, new FormData(form));
            }

            syncHeroParams(params);
            normalizeFilterParams(params);

            const targetUrl = buildTargetUrl(params);

            saveRecentSearch(params, targetUrl);

            navigateHeroSearch(targetUrl);
        }, true);
    }
